type ToastMessage = { severity: string; summary: string; life?: number }
type Listener = (msg: ToastMessage) => void

let listener: Listener | null = null

export const toastBus = {
  on(fn: Listener) {
    listener = fn
  },
  emit(msg: ToastMessage) {
    listener?.(msg)
  },
}
